import Abstract from './abstract';

export default class ABTestingView extends Abstract {
  init() {
    this.getPatternData();

    this.getElement();

    this.setViewPattern();

    this.addEvent();
  }

  getPatternData() {
    this.nextArticleAbTestPatternData = {
      targetClass: "js-next-article-ab-test-pattern-b",
      ...(window.currentNextArticleAbTestData || {}),
    };
  }

  getElement() {
    const { targetClass: nextArticleClassname } = this.nextArticleAbTestPatternData;
    if (nextArticleClassname) {
      this.nextArticleAbTestElements = document.querySelectorAll(`.${nextArticleClassname}`);
    }
  }

  setViewPattern() {
    if (this.nextArticleAbTestElements) {
      this.nextArticleAbTestElements.forEach((el) => {
        el.classList.remove('isHidden');
      });
    }
  }

  addEvent() {
  }
}
